import { IdentifierDTO } from '@zazume/zzm-base';

export const InvoicesKeys = {
  base: ['invoices'],
  getAll: (
    organizationId: IdentifierDTO,
    startDate?: string,
    endDate?: string,
    unitId?: IdentifierDTO,
    type?: string,
    number?: string
  ) => [...InvoicesKeys.base, organizationId, startDate, endDate, unitId, type, number].filter(Boolean) as string[],
  findIssued: (
    organizationId: IdentifierDTO,
    startDate?: string,
    endDate?: string,
    unitId?: IdentifierDTO,
    type?: string,
    number?: string,
    externalStatus?: string
  ) =>
    [...InvoicesKeys.base, 'issued', organizationId, startDate, endDate, unitId, type, number, externalStatus].filter(
      Boolean
    ) as string[],
  findReceived: (
    organizationId: IdentifierDTO,
    startDate?: string,
    endDate?: string,
    unitId?: IdentifierDTO,
    type?: string,
    number?: string,
    externalStatus?: string,
    visibility?: string
  ) =>
    [
      ...InvoicesKeys.base,
      'received',
      organizationId,
      startDate,
      endDate,
      unitId,
      type,
      number,
      externalStatus,
      visibility
    ].filter(Boolean) as string[],
  units: ['invoices', 'units'],
  hasOtherOwnerInvoicesVisibility: ['invoices', 'hasOtherOwnerInvoicesVisibility'],
  fromExpense: (expenseId: IdentifierDTO) => [...InvoicesKeys.base, 'expense', expenseId],
  fromIncome: (incomeId: IdentifierDTO) => [...InvoicesKeys.base, 'income', incomeId],
  fromDocument: (documentId: IdentifierDTO) => [...InvoicesKeys.base, 'document', documentId],
  fromInvoice: (invoiceId: IdentifierDTO) => [...InvoicesKeys.base, 'invoice', invoiceId]
};
